// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-panel {
  padding: 0.75rem 1rem;
  border: 1px solid var(--bs-border-color);
  border-radius: 0.5rem;
}

.search-main-row {
  display: flex;
  align-items: flex-end;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.search-input-wrap {
  flex: 1 1 200px;
  min-width: 160px;
}


.date-range-wrap {
  display: flex;
  align-items: flex-end;
  gap: 0.4rem;
}

.date-field {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.date-label {
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  color: var(--bs-secondary-color);
  margin-bottom: 0;
}

.date-arrow {
  color: var(--bs-secondary-color);
  padding-bottom: 0.35rem;
}

.date-clear-btn {
  border-left: none;
}

.date-clear-btn:hover {
  color: var(--bs-danger);
  border-color: var(--bs-danger);
}

.search-actions {
  display: flex;
  gap: 0.4rem;
  align-items: center;
}

.search-clear-btn:hover {
  color: var(--bs-danger);
  border-color: var(--bs-danger);
}

/* Theme-aware controls scoped to search panel */
.search-panel .form-control,
.search-panel .form-select {
  color: var(--bs-body-color);
  border-color: var(--bs-border-color);
}

.search-panel .form-control:focus {
  color: var(--bs-body-color);
}

.search-panel .input-group-text,
.search-panel .btn-outline-secondary {
  color: var(--bs-body-color);
  border-color: var(--bs-border-color);
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
